import { Pipe, PipeTransform } from '@angular/core';
import { CategoryModel } from '@app/core/models';

@Pipe({
  name: 'sortCategories',
  standalone: true,
})
export class SortCategoriesPipe implements PipeTransform {
  transform(categories: CategoryModel[]): CategoryModel[] {
    if (!categories) return [];
    return [...categories].sort((a, b) => (a.sort || 0) - (b.sort || 0));
  }
}
